<template>
  <div>
    <div class="is-border-top is-border-right is-border-left is-margin-top columns is-gapless is-marginless has-background-light">
      <div class="column">
        <tabs
          :links="tabsRdvs"
          :level="2"
          mode="emitter"
          @changeView="tab = $event"
          classes="has-background-light"
          :current-tab="tab"></tabs>
      </div>
      <div
        class="column is-narrow is-border-left is-self-stretched"
        v-if="tab === 'SELECTION'">
        <a
          @click="searchNewEntity()"
          class="button is-radiusless is-small is-light is-minH100 has-text-grey is-uppercase">
          <span class="icon is-small"><i class="fal fa-plus"></i></span>
          <span>Ajouter une Entrée</span>
        </a>
      </div>
      <div
        class="column is-narrow is-border-left is-self-stretched"
        v-if="tab === 'SELECTION'">
        <a
          @click="clearSelection()"
          data-tooltip="Supprimer toute la selection"
          class="tooltip is-tooltip-left button is-radiusless is-danger is-square is-uppercase">
          <span class="icon is-small"><i class="fal fa-trash-alt"></i></span>
        </a>
      </div>
    </div>
    <div class="statisticsRows-header statisticsRows-header--sticky is-border-right is-border-left has-background-white">
      <div class="columns is-gapless is-size-6-touch is-size-6-desktop is-size-5-widescreen is-marginless-bottom">
        <div class="column is-2 is-border-right"></div>
        <div class="column is-2 has-text-centered is-border-right">
          <br>Total
        </div>
        <div class="column is-2 has-text-centered is-border-right">
          <br>Effectués
        </div>
        <div class="column is-1 has-text-centered is-border-right">
          <br>Annulés
        </div>
        <div class="column is-one-fifth has-text-centered is-border-right">
          <br>Taux transformation
        </div>
        <div class="column is-2 has-text-centered">
          <!-- <span :data-tooltip="'du ' + futureStartDate + ' au ' + futureEndDate" class="tooltip is-tootltip-primary "> -->
          <br>A venir
          <!-- </span> -->
        </div>
      </div>
      <div class="columns is-gapless is-size-6-touch is-size-6-desktop is-size-5-widescreen">
        <div class="columns column is-2 is-vcentered is-border-right">
          <div class="column is-paddingless-right is-padding-top is-padding-bottom is-padding-left-small">
            <span>Entité</span>
          </div>
        </div>
        <div class="columns column is-2 is-border-right">
          <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
            <span>R0</span>
          </div>
          <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
            <span>R1</span>
          </div>
          <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
            <span>R2</span>
          </div>
          <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
            <span>R3</span>
          </div>
        </div>
        <div class="columns column is-2 is-border-right">
          <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
            <span>R0</span>
          </div>
          <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
            <span>R1</span>
          </div>
          <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
            <span>R2</span>
          </div>
          <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
            <span>R3</span>
          </div>
        </div>
        <div class="columns column is-1 is-border-right">
          <div class="column is-th is-paddingless-right is-paddingless-left has-text-centered">
            <span>RDV</span>
          </div>
        </div>
        <div class="columns column is-one-fifth is-border-right">
          <div class="column is-4 is-th is-paddingless-right is-padding-left-small">
            <span>R0-R1</span>
          </div>
          <div class="column is-4 is-th is-paddingless-right is-padding-left-small">
            <span>R1-R2</span>
          </div>
          <div class="column is-4 is-th is-paddingless-right is-padding-left-small">
            <span>R2-R3</span>
          </div>
        </div>
        <div class="columns column is-2">
          <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
            <span>R0</span>
          </div>
          <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
            <span>R1</span>
          </div>
          <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
            <span>R2</span>
          </div>
          <div class="column is-3 is-th is-paddingless-right is-padding-left-small">
            <span>R3</span>
          </div>
        </div>
      </div>
    </div>
    <div class="statisticsRows-lignes is-size-6-touch is-size-6-desktop is-size-5-widescreen">
      <stats-rdvs-row
        v-for="s in rdvsEntities"
        :key="s.key"
        :entity="s"
        class="has-background-white is-border is-relative is-clipped is-margin-bottom-small"
        @remove="removeEntity"
        :can-be-remove="tab === 'SELECTION'"></stats-rdvs-row>
      <stats-rdvs-row
        :entity="totalEntities"
        :is-total="true"
        class="statisticsRows-ligne--synthese statisticsRows-ligne--synthese--nowrap-xLargeScreen"></stats-rdvs-row>
    </div>
    <div v-if="tab === 'SELECTION'">
      <a
        @click="searchNewEntity()"
        class="columns is-vcentered is-gapless is-border is-border--primary has-link-grey is-padding-small is-border--dashed is-margin-top-small is-margin-bottom-small">
        <div class="column is-uppercase">Ajouter une entrée</div>
        <div class="column is-narrow"><span><i class="fal fa-plus-square"></i></span></div>
      </a>
    </div>
  </div>
</template>

<script>
import StatsMixins from '../StatsMixins'
import { Quickview } from '@/mixins'
import { mapState } from 'vuex'

export default {
  name: 'StatsRdvs',
  components: {
    StatsRdvsRow: () => import('./StatsRdvsRow')
  },
  mixins: [StatsMixins, Quickview],
  data () {
    return {
      tab: 'SELLERS',
      tabsRdvs: [
        { link: 'SELLERS', label: 'Vendeurs' },
        { link: 'SELECTION', label: 'Ma Sélection' }
      ],
      rdvsSelection: []
    }
  },
  computed: {
    ...mapState(['quickview']),
    totalEntities () {
      if (this.tab === 'SELLERS') {
        return this.statsRdvs
      } else if (this.tab === 'SELECTION') {
        return this.rdvsSelectionList
      } else {
        return []
      }
    },
    rdvsEntities () {
      if (this.tab === 'SELLERS') {
        return this.processedStatsRdvs
      } else if (this.tab === 'SELECTION') {
        return this.processedStatsRdvsSelection
      } else {
        return []
      }
    },
    rdvsSelectionList () {
      let selection = []
      this.rdvsSelection.forEach(entity => {
        let selectedRdv = this.statsRdvs.filter(x => x.user && x.user.pk === entity.pk)
        if (!selectedRdv || !selectedRdv.length) selectedRdv = [{ ...entity, user: entity }]
        selection = [...selection, ...selectedRdv]
      })
      return selection
    },
    processedStatsRdvs () {
      const entityNameGenerator = rdv => `${rdv.user.first_name} ${rdv.user.last_name}`
      return this.computeEntityData(this.statsRdvs, 'user.pk', 'user', entityNameGenerator)
    },
    processedStatsRdvsSelection () {
      const entityNameGenerator = rdv => `${rdv.user.first_name} ${rdv.user.last_name}`
      return this.computeEntityData(this.rdvsSelectionList, 'user.pk', 'user', entityNameGenerator)
    }
  },
  watch: {
    'sourceStatsRdvs' (v) {
      this.updateSources({ rdvs: v })
    },
    quickview ({ mode, params, results }) {
      if (mode === 'USER_SELECTION' && results) {
        this.updateRdvsSelection(results.entities)
      }
    }
  },
  mounted () {
    if (localStorage.getItem('stats_rdvs_selection')) {
      this.rdvsSelection = JSON.parse(localStorage.getItem('stats_rdvs_selection'))
    }
  },
  methods: {
    searchNewEntity () {
      let params = {
        facets: {
          USER: []
        },
        mode: 'append'
      }
      this.rdvsSelection.forEach(seller => {
        params.facets.USER.push([`pk:-${seller.pk}`])
      })
      this.openUserSelectionQuickview(params)
    },
    updateRdvsSelection (entities) {
      entities.forEach(entity => {
        this.rdvsSelection.push({ pk: entity.pk, first_name: entity.first_name, last_name: entity.last_name })
      })
      localStorage.setItem('stats_rdvs_selection', JSON.stringify(this.rdvsSelection))
      this.$store.commit('closeQuickview')
    },
    removeEntity (entity) {
      let idx = this.rdvsSelection.findIndex(x => x.pk === entity.pk)
      if (idx >= 0) {
        this.rdvsSelection.splice(idx, 1)
        localStorage.setItem('stats_rdvs_selection', JSON.stringify(this.rdvsSelection))
      }
    },
    clearSelection () {
      localStorage.setItem('stats_rdvs_selection', [])
      this.rdvsSelection = []
    }
  }
}
</script>
